<script lang="ts" setup>
import { ButtonInput, Input } from '@brighterly/lib-lumee-ui'

import { qaConfig } from '@shared/config'

import { useLessonRoomStore } from '../../model/store'
import { useLessonRoomChatView } from '../../model/lesson-room/lesson-room-chat-view.hook'
import LessonRoomPopup from './LessonRoomPopup.vue'
import LessonRoomChatMessage from './LessonRoomChatMessage.vue'

defineOptions({
  name: 'LessonRoomChat',
})

const lessonRoomStore = useLessonRoomStore()
const { draft, toggleChat, submitMessage } = useLessonRoomChatView()
</script>

<template>
  <LessonRoomPopup
    v-if="lessonRoomStore.isChatOpen"
    title="Chat"
    @close="toggleChat"
  >
    <div class="lesson-room-chat">
      <div class="lesson-room-chat__messages">
        <LessonRoomChatMessage
          v-for="(message, index) in lessonRoomStore.getChatMessages"
          :key="index"
          :message="message"
        />
        <div ref="messagesEnd" />
      </div>

      <form
        class="lesson-room-chat__controls"
        @submit.prevent="submitMessage"
      >
        <Input
          v-model="draft"
          placeholder="Send a message"
          :data-qa="qaConfig.attributes.inputChat"
        >
          <template #action>
            <ButtonInput
              text="Send"
              :disabled="!draft.trim()"
              :data-qa="qaConfig.attributes.buttonChatSubmit"
              @click="submitMessage"
            />
          </template>
        </Input>
      </form>
    </div>
  </LessonRoomPopup>
</template>

<style scoped lang="scss" src="./LessonRoomChat.scss" />